module.exports = __webpack_public_path__ + "img/bg_daily_meal.c71fae42.png";